import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import type { RibbonGroupId } from "owa-ribbon-ids";
import type { RibbonFlyoutAnchorProps } from "owa-acui";
import { owaComputedFn } from "owa-computed-fn";

/**
 * Gets common group flyout for search tools tab
 * For now, returns undefined as search tools don't have complex flyouts
 */
export const getMLRSearchToolsTabCommonGroupFlyout: (_groupId: RibbonGroupId, _props: ReadOnlyRibbonControlDefProps) => RibbonFlyoutAnchorProps | undefined = owaComputedFn(function getMLRSearchToolsTabCommonGroupFlyout(_groupId: RibbonGroupId, _props: ReadOnlyRibbonControlDefProps): RibbonFlyoutAnchorProps | undefined {
    // No complex flyouts for search tools tab for now
    return undefined;
});
